<div class="search-input-wrapper">
  <input
    type="text"
    class="search-input"
    placeholder="Search orders, retrievals, billing..."
    [value]="query()"
    (input)="onInput($event)"
  />
  @if (query().length > 0) {
    <button
      type="button"
      class="search-input__clear"
      aria-label="Clear search"
      (click)="clearSearch()"
    >
      ×
    </button>
  }
</div>

@if (loading()) {
  <p class="search-status">Searching...</p>
}

@if (salesOrders().length > 0) {
  <div class="search-category">
    <h3 class="search-category__header">
      Sales Orders
      <span class="search-category__count">({{ salesOrders().length }})</span>
    </h3>
    <ul class="search-results">
      @for (order of salesOrders(); track order.id) {
        <li class="search-result-row" (click)="openSalesOrderDetail(order)">

          <div class="search-result-row__primary">{{ order.number }}</div>
          <div class="search-result-row__secondary">
            @if (order.referenceNumber) {
              <span>BOL: {{ order.referenceNumber }}</span>
            }
            <span>{{ getOrderStatusLabel(order.status) }}</span>
            @if (order.date) {
              <span>{{ order.date | date: 'shortDate' }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </div>
}

@if (cprs().length > 0) {
  <div class="search-category">
    <h3 class="search-category__header">
      Customer Retrievals
      <span class="search-category__count">({{ cprs().length }})</span>
    </h3>
    <ul class="search-results">
      @for (cpr of cprs(); track cpr.id) {
        <li class="search-result-row" (click)="openCprDetail(cpr)">

          <div class="search-result-row__primary">{{ cpr.cprNumber }}</div>
          <div class="search-result-row__secondary">
            @if (cpr.customerReferenceNumber) {
              <span>Ref: {{ cpr.customerReferenceNumber }}</span>
            }
            <span>{{ getOrderStatusLabel(cpr.status) }}</span>
            @if (cpr.details?.length) {
              <span>Qty: {{ getCprTotalQuantity(cpr) }}</span>
            }
            @if (cpr.date) {
              <span>{{ cpr.date | date: 'shortDate' }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </div>
}

@if (salesInvoices().length > 0) {
  <div class="search-category">
    <h3 class="search-category__header">
      Sales Invoices
      <span class="search-category__count">({{ salesInvoices().length }})</span>
    </h3>
    <ul class="search-results">
      @for (row of salesInvoices(); track row.id) {
        <li class="search-result-row" (click)="openInvoiceDetail(row)">

          <div class="search-result-row__primary">{{ row.refNumber }}</div>
          <div class="search-result-row__secondary">
            @if (row.acctName) {
              <span>{{ row.acctName }}</span>
            }
            @if (row.date) {
              <span>{{ row.date | date: 'shortDate' }}</span>
            }
            @if (row.totalAmount != null) {
              <span>{{ row.totalAmount | currency: 'USD' }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </div>
}

@if (otherBillingResults().length > 0) {
  <div class="search-category">
    <h3 class="search-category__header">
      Billing History
      <span class="search-category__count">({{ otherBillingResults().length }})</span>
    </h3>
    <ul class="search-results">
      @for (row of otherBillingResults(); track row.id) {
        <li class="search-result-row" (click)="openInvoiceDetail(row)">

          <div class="search-result-row__primary">{{ row.refNumber }}</div>
          <div class="search-result-row__secondary">
            @if (row.acctName) {
              <span>{{ row.acctName }}</span>
            }
            @if (row.billingType != null) {
              <span>{{ getBillingTypeLabel(row.billingType) }}</span>
            }
            @if (row.totalAmount != null) {
              <span>{{ row.totalAmount | currency: 'USD' }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </div>
}

@if (locations().length > 0) {
  <div class="search-category">
    <h3 class="search-category__header">
      Locations
      <span class="search-category__count">({{ locations().length }})</span>
    </h3>
    <ul class="search-results">
      @for (loc of locations(); track loc.id) {
        <li class="search-result-row" (click)="goToLocation(loc)">
          <div class="search-result-row__primary">{{ loc.locationName }}</div>
          <div class="search-result-row__secondary">
            @if (loc.addressLine1 || loc.addressCity) {
              <span>{{ loc.addressLine1 }} {{ loc.addressCity }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </div>
}

@if (showEmpty()) {
  <p class="search-status">No results found.</p>
}
